import FeatureFlags from "@arcteryx/js-feature-flags";

export const FeatureSet = FeatureFlags.define([
  "RedirectJapanToArcteryxJP",
  "enableMagentoMcProd",
  "enableMagentoStaging1",
  "enableMagentoStaging2",
  "enableMagentoStaging4",
  "enableMagentoStaging5",
  "enableOutletFlashSaleModal",
  "enableSanityPromoBar",
  "useAlgoliaPreprod",
]);
